import Music2 from './Music2'
export default Music2
